// Component disabled on purpose

import StandaloneAffiliateGallery from 'base/components/AffiliateGallery';

export default (() => null) as typeof StandaloneAffiliateGallery;
